module.exports = __webpack_public_path__ + "img/bg-title-bg.4385e066.png";